"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _table = _interopRequireDefault(require("../../../../core/table"));
var _editableField = _interopRequireDefault(require("../../../../core/editable-field"));
var _tooltip = _interopRequireDefault(require("../../../../core/tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("h4", {
  className: "card-header"
}, "Override Dates for Specific Entry Types");
var _ref2 = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null, "Entry Type"), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
  placement: "top",
  overlay: "When an override open date is later than the main competition open date, paddlers in this category will not have entries accepted until the override open date"
}, /*#__PURE__*/_react.default.createElement("th", null, "Open For Entries")), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
  placement: "top",
  overlay: "When an override open date is later than the main competition open date, this allows the paddler to Pre-register on the waiting list"
}, /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, "Can Pre-register")), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
  placement: "top",
  overlay: "When set this will override, for the specified entry type, the 'Entries Close' set for the Competition"
}, /*#__PURE__*/_react.default.createElement("th", null, "Entries Close")), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
  placement: "top",
  overlay: "When set this will override, for the specified entry type, the 'Late Fees Become Due' set for the Competition"
}, /*#__PURE__*/_react.default.createElement("th", null, " Late Fees Become Due"))));
class EntryTypeOverrides extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onChange", (id, field, value) => {
      this.props.onUpdate(id, field, value);
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, _ref, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement(_table.default, null, _ref2, /*#__PURE__*/_react.default.createElement("tbody", null, this.props.entryTypeOverrides.map(entryType => /*#__PURE__*/_react.default.createElement("tr", {
      key: entryType.id
    }, /*#__PURE__*/_react.default.createElement("td", null, entryType.entryTypeDescription), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: this.props.userIsSystemAdmin,
      type: "Date",
      name: "openForOnlineEntryDate",
      value: entryType.openForOnlineEntryDate,
      onChange: this._onChange.bind(this, entryType.id, 'openForOnlineEntryDate')
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-center"
    }, !entryType.openForOnlineEntryDate ? null : /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: this.props.userIsSystemAdmin,
      type: "Checkbox",
      name: "canPreRegister",
      checked: entryType.canPreRegister,
      onChange: this._onChange.bind(this, entryType.id, 'canPreRegister')
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      type: "Date",
      name: "closedForOnlineEntryDate",
      value: entryType.closedForOnlineEntryDate,
      onChange: this._onChange.bind(this, entryType.id, 'closedForOnlineEntryDate')
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      type: "Date",
      name: "lateFeesDueDate",
      value: entryType.lateFeesDueDate,
      onChange: this._onChange.bind(this, entryType.id, 'lateFeesDueDate')
    }))))))));
  }

  // ****************************************************************************
  // PartialQuery definition
  // ****************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(EntryTypeOverrides, "partials", {
  EntryTypeOverrides: {
    id: true,
    entryTypeDescription: true,
    openForOnlineEntryDate: true,
    canPreRegister: true,
    closedForOnlineEntryDate: true,
    lateFeesDueDate: true
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(EntryTypeOverrides, undefined, (client, props) => ({
  onUpdate(id, field, value) {
    return client.update('EntryTypeOverride.set', {
      id,
      field,
      value
    });
  }
}));